<template>
  <div class="col-big-vbspace basic-form">
    <div class="col-vspace flex-radio">
      <div class="flex-radio__data">
        <label class="label--textarea" for="choice-list">Date</label>

        <DatePicker v-model="innerDate" />
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from '../../utils';
import { formatDate } from '../../../mixins';

export default {
  components: { DatePicker },

  mixins: [ formatDate ],

  data() {
    return {
      date: this.today(),
    };
  },

  computed: {
    innerDate: {
      get() {
        return this.date;
      },
      set(newValue) {
        this.date = newValue;
        this.$emit('change-name', newValue);
      }
    }
  },

  methods: {
    today() {
      return this.prettyDate(Date.now());
    },
  },
};
</script>
